import MetricDashCard from "../../../../../../../../components/dash-card/metric-dash-card.jsx";
import ProjectUtils from "../../../../../../../../utils/project-utils.js";

function InfoCard({ title, label, value }) {
    return (
        <div className="space-y-2! mb-4">
            <p className="text-[16px] text-[#AAAAAA] pl-3">
                {title}
            </p>
            <MetricDashCard
                counterCard
                title={ProjectUtils.sentenceCase(label)}
                value={value}
                height={105}
                dashClassName="w-full!"
            />
        </div>
    )
}

export default function MostRegistered({ data }) {
    const topNeighborhood = data?.topNeighborhoods?.[0];
    const topProgram = data?.cnpjRegistrationsByProgram?.[0];

    return (
        <article className="grid grid-cols-2 gap-4">
            <InfoCard
                title={<>Bairro mais <br/> cadastrado</>}
                label={topNeighborhood?.label}
                value={topNeighborhood?.qty}
            />
            <InfoCard
                title={<>Programa <br/> mais cadastrado</>}
                label={topProgram?.label}
                value={topProgram?.qty}
            />
        </article>
    )
}
